module.exports = __webpack_public_path__ + "img/Flag_of_Colombia.056cc103.svg";